
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// http://localhost/rutas/backend
export const environment = {
  production:false,
  apiUrl:"http://www.pregrado.unal.edu.co/pruebas/rutas/"
  //apiUrl:"http://localhost/rutas/backend/"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts